<script setup>
import CFPlainCheckbox from '@/shared/components/CFPlainCheckbox.vue';
import CFBadge from '@/ui/Badge/CFBadge.vue';
import { getFormattedPrice } from '@/shared/utils/helpers.js';

defineProps({
    invoice: {
        type: Object,
        required: true,
    },
    active: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    onClick: {
        type: Function,
        required: true,
    },
});

const modelValue = defineModel({
    type: Array,
});
</script>

<template>
    <div
        class="invoice-sidebar-item border-b-primary relative flex w-full max-w-full min-w-0 items-start gap-3 border-b px-3 py-5 transition-all ease-in"
        :class="{
            'bg-neutrals-400': active,
            'hover:bg-neutrals-400/75': !active,
        }"
    >
        <div class="shrink-0">
            <CFPlainCheckbox
                v-model="modelValue"
                v-tooltip="{
                    content: $t('invoices.can_only_select_up_to_three_invoices'),
                    disabled: !disabled,
                }"
                :value="invoice.id"
                :disabled="disabled"
            />
        </div>
        <div
            class="grow cursor-pointer"
            @click="onClick(invoice.id)"
        >
            <div class="mb-1 flex items-center gap-2">
                <div class="font-bold">{{ invoice.attributes.number }}</div>
                <div class="bg-primary h-1.5 w-1.5 rounded-full"></div>
                <div class="text-primary text-sm">
                    {{ invoice.attributes.created_at }}
                </div>
            </div>
            <div class="flex items-center gap-2">
                <CFBadge
                    v-if="invoice.attributes.paid_at"
                    size="xs"
                    color="success"
                >
                    {{ $t('invoices.paid') }}
                </CFBadge>
                <CFBadge
                    v-else
                    size="xs"
                    color="info"
                >
                    {{ $t('invoices.open') }}
                </CFBadge>
                <div class="text-neutrals-700 text-sm">{{ getFormattedPrice(invoice.attributes.amount_incl) }}</div>
            </div>
        </div>
    </div>
</template>
